import { settings } from "../../../../settings/settings-util";

export default function toggleWindowFormToState(passedSettings: typeof settings, disabled: boolean): void {
    const { multilineTextField, singleLineTextField, copyButton, formClearFieldsButton, formAppEventButton } = passedSettings.classNames.windowForm;
    const elements = document.querySelectorAll(`.${multilineTextField}, .${singleLineTextField}, .${copyButton}, .${formClearFieldsButton}, .${formAppEventButton}`);

    Array.from(elements).forEach(element => {
        if (disabled) {
            (element as HTMLElement).setAttribute('disabled', 'true');
        }
        else {
            (element as HTMLElement).removeAttribute('disabled');
        }
    });
}



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/element-disabler/src/disablers/windowForm.ts